import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface WebsiteConfig {
  url: {
    en: string;
    de: string;
  };
  uiText: {
    header: {
      en: string;
      de: string;
    };
    subtitle: {
      en: string;
      de: string;
    };
    buttons: {
      changeUrl: {
        en: string;
        de: string;
      };
      openNewTab: {
        en: string;
        de: string;
      };
    };
  };
}

const websiteConfig: WebsiteConfig = {
  url: {
    en: 'https://example.com',
    de: 'https://beispiel.de',
  },
  uiText: {
    header: {
      en: 'Example Website',
      de: 'Beispiel-Website',
    },
    subtitle: {
      en: 'Simple Demo',
      de: 'Einfache Demo',
    },
    buttons: {
      changeUrl: {
        en: 'Change URL',
        de: 'URL ändern',
      },
      openNewTab: {
        en: 'Open in New Tab',
        de: 'In neuem Tab öffnen',
      },
    },
  },
};

const generateWebsiteTemplateContent = (language: 'en' | 'de'): string => {
  const url = websiteConfig.url[language];

  return `
  <div style="display: flex; flex-direction: column; height: 100%; font-family: 'Be Vietnam Pro', sans-serif; color: #282a32;">
    <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
      <div style="font-weight: 600; color: #282a32;">${websiteConfig.uiText.header[language]}</div>
      <div style="font-size: 0.85rem; color: #686b87;">${websiteConfig.uiText.subtitle[language]}</div>
    </div>
    <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
      <div style="padding: 8px 12px; background-color: #f3f4f6; border-radius: 8px 8px 0 0; display: flex; align-items: center; border: 1px solid #eff1f6; border-bottom: none;">
        <div style="display: flex; gap: 6px; margin-right: 10px;">
          <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #ef4444;"></div>
          <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #f59e0b;"></div>
          <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #10b981;"></div>
        </div>
        <div style="flex: 1; background-color: #ffffff; border-radius: 4px; padding: 4px 8px; font-size: 0.85rem; color: #686b87; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          ${url}
        </div>
      </div>
      <div style="flex: 1; border: 1px solid #eff1f6; border-radius: 0 0 8px 8px; overflow: hidden; position: relative; background-color: #fdfcff;">
        <iframe src="${url}" style="width: 100%; height: 100%; border: none;" title="Example Website Preview" sandbox="allow-same-origin allow-scripts"></iframe>
      </div>
    </div>
    <div style="margin-top: 12px; display: flex; justify-content: space-between; align-items: center;">
      <button style="background-color: transparent; color: #434ce8; border: 1px solid #434ce8; border-radius: 8px; padding: 8px 16px; font-size: 0.85rem; font-weight: 500; cursor: pointer;">${websiteConfig.uiText.buttons.changeUrl[language]}</button>
      <button style="background-color: #434ce8; color: white; border: none; border-radius: 8px; padding: 8px 16px; font-size: 0.85rem; font-weight: 500; cursor: pointer;">${websiteConfig.uiText.buttons.openNewTab[language]}</button>
    </div>
  </div>`;
};

export const exampleWebsiteTemplateWidget: MultilingualWidgetConfig = {
  id: 'example-website-template',
  translations: {
    en: {
      title: websiteConfig.uiText.header.en,
      content: generateWebsiteTemplateContent('en'),
    },
    de: {
      title: websiteConfig.uiText.header.de,
      content: generateWebsiteTemplateContent('de'),
    },
  },
  x: 2,
  y: 0,
  w: 3,
  h: 6,
};
